/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RtbAPI {

  /**
   * Method that returns a list of currencies
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCurrencyList(): CancelablePromise<Array<{
    id: string;
    exchange_rate: number;
    updated_at: string | null;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/currency/list',
    });
  }

  /**
   * Method that returns a particular currency
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCurrency(
    id: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/currency/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns a list of supported RTB features
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiFeatureList(): CancelablePromise<Array<{
    id: number;
    name: 'click_url' | 'click_macros' | 'bidswitch_multi_dsp' | 'user_matched_traffic' | 'send_publisher_id' | 'delayed_impression' | 'send_site_page' | 'send_site_domain' | 'send_site_categories' | 'send_site_keywords' | 'send_site_domain_override' | 'appnexus_language_id_as_publisher_id' | 'send_impression_viewability' | 'block_desktop' | 'block_mobile' | 'block_banner' | 'block_video' | 'iframe_cookie_sync' | 'send_bid_floor';
    level: 'public' | 'private' | null;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/feature/list',
    });
  }

  /**
   * Method that returns a list of supported RTB versions
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiVersionList(): CancelablePromise<Array<{
    id: number;
    name: string;
    version: number | null;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/version/list',
    });
  }

  /**
   * Method that returns a list of seats
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param id
   * @param seatid
   * @param dspId
   * @param name
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiSeatList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    id?: number,
    seatid?: string,
    dspId?: number,
    name?: string | null,
  ): CancelablePromise<Array<{
    id: number;
    seatid: string;
    dsp_id: number;
    name: string | null;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/seat/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'id': id,
        'seatid': seatid,
        'dsp_id': dspId,
        'name': name,
      },
    });
  }

  /**
   * Method that returns a count of seats
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param id
   * @param seatid
   * @param dspId
   * @param name
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiSeatCount(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    id?: number,
    seatid?: string,
    dspId?: number,
    name?: string | null,
  ): CancelablePromise<{
    count: number;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/seat/count',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'id': id,
        'seatid': seatid,
        'dsp_id': dspId,
        'name': name,
      },
    });
  }

  /**
   * Method that returns a list of RTB sources
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiSourceList(): CancelablePromise<Array<{
    id: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/source/list',
    });
  }

}
